/*
 * @Author: Zhouqi
 * @Date: 2026-01-20 16:24:12
 * @LastEditors: Zhouqi
 * @LastEditTime: 2026-01-21 18:29:18
 */
import { Turnstile, TurnstileInstance } from '@marsidev/react-turnstile';
import { forwardRef, useImperativeHandle, useRef } from 'react';

import { isProduction } from '@/utils/envHelper';

export type TurnstileMode = 'invisible' | 'managed';

interface TurnstileWrapperProps {
  onSuccess: (token: string) => void;
  onError?: () => void;
  onExpire?: () => void;
  mode?: TurnstileMode; // 'invisible' for first verification, 'managed' for second verification
}

export interface TurnstileWrapperRef {
  execute: () => void;
  reset: () => void;
}

export const TurnstileWrapper = forwardRef<TurnstileWrapperRef, TurnstileWrapperProps>(
  ({ onSuccess, onError, onExpire, mode = 'invisible' }, ref) => {
    const turnstileRef = useRef<TurnstileInstance>(null);

    const siteKey =
      (mode === 'invisible'
        ? isProduction
          ? process.env.NEXT_PUBLIC_TURNSTILE_PROD_INVISIBLE_SITE_KEY
          : process.env.NEXT_PUBLIC_TURNSTILE_INVISIBLE_SITE_KEY
        : isProduction
          ? process.env.NEXT_PUBLIC_TURNSTILE_PROD_MANAGED_SITE_KEY
          : process.env.NEXT_PUBLIC_TURNSTILE_MANAGED_SITE_KEY) || '';

    useImperativeHandle(ref, () => ({
      execute: () => {
        turnstileRef.current?.execute?.();
      },
      reset: () => {
        turnstileRef.current?.reset?.();
      },
    }));

    return (
      <div className="flex justify-center my-4">
        <Turnstile
          ref={turnstileRef}
          siteKey={siteKey}
          onSuccess={onSuccess}
          onError={onError}
          onExpire={onExpire}
          options={{
            theme: 'light',
            size: mode === 'invisible' ? 'invisible' : 'normal',
            appearance: mode === 'invisible' ? 'interaction-only' : 'always',
          }}
        />
      </div>
    );
  },
);

TurnstileWrapper.displayName = 'TurnstileWrapper';

export default TurnstileWrapper;
